import React from 'react'
import { Container, Row, Tab, Tabs } from 'react-bootstrap';
import styles from '../Measures/Measures.module.scss';
import { data } from '../data';
import { Link } from 'react-router-dom';

const NewList = () => {

    return (<>

        <Container className='outerContainer'>
            <Tabs defaultActiveKey="all-news" className={'qiTabs'}>
                <Tab eventKey="all-news" title="All News">
                    <Container className={styles.cardContainer}>
                        <Row>
                            {data.News.map((info) => (<>

                                <p id={info.id} className="mb-0 mt-1">{info.date ? <h6>{info.date}</h6> : null}</p>
                                <h4><a href={info.url}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>

                                <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-1 mb-3" />
                                <hr />

                            </>)
                            )}
                        </Row>
                    </Container>
                </Tab>
                <Tab eventKey="software-releases" title="Software Releases and Updates">
                    <Container className={styles.cardContainer}>
                        <Row>
                            {data.News.map((info) => (<>
                                {info.category && info.category.includes("software") ?
                                <>
                                <p className="mb-0 mt-3">{info.date ? <h6>{info.date}</h6> : null}</p>
                                <h4><a href={info.url}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>

                                <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-3 mb-3" />
                                <hr /></>
                                : null 
                            }
                            </>)
                            )}
                        </Row>
                    </Container>
                </Tab>
                <Tab eventKey="indicator-changes" title="Indicator Changes">
                    <Container className={styles.cardContainer}>
                        <Row>
                            {data.News.map((info) => (<>
                                {info.category && info.category.includes("indicator") ?
                                <>
                                <p className="mb-0 mt-3">{info.date ? <h6>{info.date}</h6> : null}</p>
                                <h4><a href={info.url}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>

                                <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-3 mb-3" />
                                <hr /></>
                                : null 
                            }

                            </>)
                            )}
                        </Row>
                    </Container>
                </Tab>
                <Tab eventKey="other" title="Other">
                    <Container className={styles.cardContainer}>
                        <Row>
                            {data.News.map((info) => (<>
                                {info.category && info.category.includes("other") ?
                                <>
                                <p className="mb-0 mt-3">{info.date ? <h6>{info.date}</h6> : null}</p>
                                <h4><a href={info.url}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>

                                <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-3 mb-3" />
                                <hr /></>
                                : null 
                            }

                            </>)
                            )}
                        </Row>
                    </Container>
                </Tab>

            </Tabs>
            <p className="mb-5">For news prior to 2017 see the <Link to="/archive/news">Archive News</Link> page</p>
        </Container>
    </>)
}

{/*
<Row>
{data.News.map((info) => (<>
    {info.category && info.category.includes('software') ?
        <Col className={styles.columns} md={4}>
            <Card className={styles.cards}>
                <Card.Header className={styles.cardHeader} >
                    <h5>{info.title}</h5>{info.date ? <h6>{info.date}</h6> : null}
                </Card.Header>
                <Card.Body className={styles.lightGrey}>
                    <Card.Text>
                        {info.desc}
                    </Card.Text>
                </Card.Body>
                <div className={'p-2 centerText' + ' ' + styles.lightGrey} >
                    <Button className={styles.ctaBtn} href={info.url}>View</Button>
                </div>
            </Card>
        </Col> : null}
</>)
)}
</Row>*/}

export default NewList;